import { ReactNode } from "react"
import { ToastProvider } from "popopo-lib-front/hook"
import { AnalyticsProvider } from "./analytics"

interface CommonProviderProps {
  children: ReactNode
}

export function CommonProvider({ children }: CommonProviderProps): ReactNode {
  return (
    <AnalyticsProvider>
      <ToastProvider>
        {children}
      </ToastProvider>
    </AnalyticsProvider>
  )
}
